import ReactGA from 'react-ga';
import Blog from './pages/blog';
import ContactPage from './pages/contact'
import MerchantPage from './pages/merchant'
import CommercePage from './pages/commerce'
import SignIn from './pages/signIn';
import WayaGram from './pages/wayagram';
import WayaPay from './pages/wayapay'
import Home from './pages/home'
import About from './pages/about'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import './styles/App.scss';
import WayaChat from './pages/wayachat';
import Agent from './pages/agent';
import HowItWorks from './pages/how-it-works';
import SinglePost from './pages/single-post';
import TermsOfUse from './pages/terms';
import PrivacyPage from './pages/privacy';
import PricingPage from './pages/pricing';
import DeveloperPage from './pages/developer';
import WayaPos from './pages/product/wayapos';
import WayaLoan from './pages/product/wayaloan';
import WayaBank from './pages/wayabank';
import SingleBlogCategory from './pages/single-category';
import CareerPage from './pages/career';
import FaqPage from './pages/faq';
import SupportButton from './componentParts/supportButton';
import { useEffect } from 'react';
// import SignUp from './pages/signup';
const TRACKING_ID = "G-9KVZ7KD3R4";
  ReactGA.initialize(TRACKING_ID);
function App() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <div>
      <Router>
        <Switch>
          <Route exact path="/about">
            <About />
          </Route>
          <Route exact path="/blogs">
            <Blog />
          </Route>
          <Route exact path='/agent'>
            <Agent />
          </Route>
          <Route exact path="/contact">
            <ContactPage />
          </Route>
          <Route exact path='/merchant'>
            <MerchantPage />
          </Route>
          <Route exact path='/commerce'>
            <CommercePage />
          </Route>
          <Route exact path='/product/:cat'>
            <WayaChat />
          </Route>
          <Route exact path='/developer/:cat'>
            <DeveloperPage />
          </Route>
          <Route exact path='/wayapos'>
            <WayaPos />
          </Route>
          <Route exact path='/wayaloan'>
            <WayaLoan />
          </Route>
          <Route exact path='/wayabank'>
            <WayaBank />
          </Route>
          <Route exact path='/wayapay'>
            <WayaPay />
          </Route>
          <Route exact path='/wayagram'>
            <WayaGram />
          </Route>
          <Route exact path='/wayachat'>
            <WayaChat />
          </Route>
          <Route exact path='/signin'>
            <SignIn />
          </Route>
          {/* <Route exact path='/signup'>
            <SignUp />
          </Route> */}
          <Route exact path='/pricing-page'>
            <PricingPage />
          </Route>
          <Route exact path='/how-it-works'>
            <HowItWorks />
          </Route>
          <Route exact path='/terms-of-use'>
            <TermsOfUse />
          </Route>
          <Route exact path='/privacy-page'>
            <PrivacyPage />
          </Route>
          <Route exact path='/faq'>
            <FaqPage />
          </Route>
          <Route path={`/blogs/:topicId`}>
            <SinglePost />
          </Route>
          <Route path={`/blogs-category/:id`}>
            <SingleBlogCategory />
          </Route>
          <Route path={`/career`}>
            <CareerPage />
          </Route>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/home">
            <Home />
          </Route>
        </Switch>
      </Router>
      <SupportButton/>
    </div>
  );
}

export default App;
